module.exports = __webpack_public_path__ + "6b3ccdcffe1e80bbbc429418d22e2876.svg";